import React from "react"
import DocumentListContainer from "./DocumentListContainer"

const ScopedDocumentListContainer = ({ id, slug, category, categoryId, viewType }) => (
    <DocumentListContainer
        mode="scoped"
        id={id}
        slug={slug}
        scope={category || "PARTY"}
        categoryId={categoryId || null}
        viewType={viewType || null}
    />
)

export default ScopedDocumentListContainer
